import { supabase } from "./supabase";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function authHeader() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function request(path, { method = "GET", body } = {}) {
  const headers = { "Content-Type": "application/json", ...(await authHeader()) };
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = "Request failed";
    try {
      detail = (await res.json()).detail || detail;
    } catch (e) {}
    throw new Error(detail);
  }
  return res.json();
}

export const api = {
  getProfile: () => request("/profile"),
  updateProfile: (data) => request("/profile", { method: "PUT", body: data }),
  planPreview: (data) => request("/plan/preview", { method: "POST", body: data }),
  dashboard: (date) => request(`/dashboard${date ? `?log_date=${date}` : ""}`),
  addMeal: (data) => request("/meals", { method: "POST", body: data }),
  listMeals: () => request("/meals"),
  deleteMeal: (id) => request(`/meals/${id}`, { method: "DELETE" }),
  scan: (image_base64) => request("/scan", { method: "POST", body: { image_base64, save: true } }),
  coach: (message) => request("/coach", { method: "POST", body: { message } }),
  generatePlan: (exclude) => request("/plan/generate", { method: "POST", body: { exclude } }),
  getWeight: () => request("/weight"),
  addWeight: (weight) => request("/weight", { method: "POST", body: { weight } }),
  logWater: (delta) => request("/water", { method: "POST", body: { delta } }),
  weeklyRecap: () => request("/weekly-recap"),
  getFreezes: () => request("/freezes"),
  vapidKey: () => request("/push/vapid-public-key"),
  pushSubscribe: (subscription, tz_offset) =>
    request("/push/subscribe", { method: "POST", body: { subscription, tz_offset } }),
  pushUnsubscribe: (endpoint) => request("/push/unsubscribe", { method: "POST", body: { endpoint } }),
  pushTest: () => request("/push/test", { method: "POST" }),
  getScans: () => request("/scans"),
  progress: () => request("/progress"),
  signup: (email, password, name) =>
    request("/auth/signup", { method: "POST", body: { email, password, name } }),
};
